import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, orderBy, limit } from 'firebase/firestore';
import { db } from '../../../firebase';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Button } from '../../ui/button';
import { LoadingSpinner } from '../../ui/loading-spinner';
import { useToast } from '../../../hooks/use-toast';
import { FileText } from 'lucide-react';
import { cn } from '../../../lib/utils';

const BlogListSelector = ({ onBlogSelect, selectedBlogId }) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { toast } = useToast();

  useEffect(() => {
    fetchBlogs();
  }, []);

  async function fetchBlogs() {
    setLoading(true);
    try {
      const collectionRef = collection(db, 'blog_posts');
      const q = query(collectionRef, orderBy('publishedAt', 'desc'));
      const snap = await getDocs(q);
      const items = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      setPosts(items.slice(0, 50));
      if (items.length === 0) {
        toast({ title: 'No blog posts', description: 'No blog posts found in Firestore', variant: 'warning' });
      }
    } catch (e) {
      console.error('fetchBlogs error', e);
      toast({ title: 'Error', description: 'Failed to load blog posts', variant: 'destructive' });
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return (
      <Card>
        <CardContent className="p-8 text-center">
          <LoadingSpinner />
          <p className="mt-4">Loading blog posts...</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle className={cn('text-lg flex items-center gap-2')}>
            <FileText className="h-5 w-5" />
            Blog Selection
          </CardTitle>
        </CardHeader>
      </Card>

      <div className="space-y-3 max-h-96 overflow-y-auto">
        {posts.map(post => (
          <Card key={post.id} className={cn('cursor-pointer')} onClick={() => onBlogSelect(post)}>
            <CardContent className="p-3">
              <h3 className="font-semibold text-sm truncate">{post.title}</h3>
              <p className="text-xs text-muted-foreground">{post.excerpt || post.summary || ''}</p>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card>
        <CardContent className="p-4 text-center">
          <Button onClick={fetchBlogs} variant="outline" size="sm">Refresh posts</Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default BlogListSelector;
